import React from "react";
import { Box, Typography } from "@mui/material";
import FlexBetween from "./FlexBetween";

const StatBox = ({ title, value, increase, icon, description, bgColor }) => {
    return (
        <Box
            gridColumn="span 2"
            gridRow="span 1"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            p="1rem 1.25rem"
            flex="1 1 100%"
            sx={{
                backgroundColor: bgColor || "#ffffff",
                borderRadius: "8px",
                border: "1px solid #dde2ea",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            }}
        >
            <FlexBetween>
                <Typography variant="caption" sx={{ color: "#5a6a85", fontWeight: 600, fontSize: "0.6875rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                    {title}
                </Typography>
                {icon}
            </FlexBetween>
            <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color: "#1a2138", mt: 0.75, mb: 0.5 }}>
                {value}
            </Typography>
            <FlexBetween gap="1rem">
                <Typography variant="body2" fontWeight="600" sx={{ color: "#0b5cab" }}>{increase}</Typography>
                <Typography variant="caption" sx={{ color: "#5a6a85" }}>{description}</Typography>
            </FlexBetween>
        </Box>
    );
};

export default StatBox;
